<ng-template #titleTemplate>
  {{ title }}
</ng-template>

<ng-template #descriptionTemplate>
  {{
    "AstroBin's equipment database is entirely maintained by the community. Feel free to make a contribution!"
      | translate
  }}
  <a class="learn-more" href="https://welcome.astrobin.com/features/equipment-database" target="_blank">
    {{ "Learn more" }}.
  </a>
</ng-template>

<ng-template #navTemplate>
  <astrobin-equipment-item-type-nav #itemTypeNavComponent></astrobin-equipment-item-type-nav>
</ng-template>

<div class="page">
  <ng-container *ngIf="breakpointMdMin">
    <h1><ng-container [ngTemplateOutlet]="titleTemplate"></ng-container></h1>
    <small><ng-container [ngTemplateOutlet]="descriptionTemplate"></ng-container></small>
  </ng-container>

  <div class="row g-0 g-3">
    <div *ngIf="breakpointMdMin" class="col-md-4 col-xl-3">
      <ng-container [ngTemplateOutlet]="navTemplate"></ng-container>
    </div>

    <div class="col-md-8 col-xl-9">
      <div class="row">
        <div class="col order-last order-lg-first">
          <ng-container *ngIf="(loadingService.loading$ | async) === false; else loading">
            <ng-container *ngIf="!!activeBrand">
              <div *ngIf="!!activeBrand" class="card">
                <div class="card-header">{{ "Brand" | translate }} / {{ "Company" | translate }}</div>

                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-lg-3">
                      <div [style.background-image]="'url(' + logo + ')'" class="image"></div>
                    </div>
                    <div class="col">
                      <div class="label">
                        <h5>
                          {{ activeBrand.name }}
                        </h5>
                        <h6 *ngIf="!!activeBrand.website" class="website">
                          <a [href]="activeBrand.website" target="_blank">{{
                            UtilsService.shortenUrl(activeBrand.website)
                          }}</a>
                        </h6>
                      </div>

                      <table class="table table-sm table-striped properties">
                        <tbody>
                          <tr>
                            <th class="property-name">
                              {{ "Users" | translate }}
                              <astrobin-data-does-not-update-in-real-time></astrobin-data-does-not-update-in-real-time>
                            </th>
                            <td class="property-value">{{ activeBrand.userCount || 0 }}</td>
                          </tr>

                          <tr class="property">
                            <th class="property-name">
                              {{ "Images" | translate }}
                              <astrobin-data-does-not-update-in-real-time></astrobin-data-does-not-update-in-real-time>
                            </th>
                            <td class="property-value">{{ activeBrand.imageCount || 0 }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="card-footer">
                  <button (click)="closeBrand()" class="btn btn-secondary" type="button">
                    {{ "Close" | translate }}
                  </button>
                </div>
              </div>

              <table
                *ngIf="!!itemsInBrand && itemsInBrand.length > 0"
                class="table table-sm table-striped items-in-brand"
              >
                <thead>
                  <tr>
                    <th>
                      <button (click)="toggleAZSorting()" class="btn btn-link btn-no-block">
                        {{
                          equipmentItemService.getPrintablePropertyName(null, EquipmentItemDisplayProperty.NAME, true)
                        }}
                        <fa-icon *ngIf="sortOrder === ExplorerPageSortOrder.AZ_DESC" icon="sort-alpha-down"></fa-icon>
                        <fa-icon *ngIf="sortOrder === ExplorerPageSortOrder.AZ" icon="sort-alpha-up"></fa-icon>
                      </button>
                    </th>
                    <th>
                      {{ "Class" | translate }}
                    </th>
                    <th>
                      <button (click)="toggleUsersSorting()" class="btn btn-link btn-no-block">
                        {{ "Users" | translate }}
                        <fa-icon
                          *ngIf="sortOrder === ExplorerPageSortOrder.USERS_DESC"
                          icon="sort-numeric-down"
                        ></fa-icon>
                        <fa-icon *ngIf="sortOrder === ExplorerPageSortOrder.USERS" icon="sort-numeric-up"></fa-icon>
                      </button>
                    </th>
                    <th>
                      <button (click)="toggleImagesSorting()" class="btn btn-link btn-no-block">
                        {{ "Images" | translate }}
                        <fa-icon
                          *ngIf="sortOrder === ExplorerPageSortOrder.IMAGES_DESC"
                          icon="sort-numeric-down"
                        ></fa-icon>
                        <fa-icon *ngIf="sortOrder === ExplorerPageSortOrder.IMAGES" icon="sort-numeric-up"></fa-icon>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of itemsInBrand; trackBy: equipmentItemService.trackBy">
                    <td class="item-name">
                      <a
                        [href]="'/equipment/explorer/' + item.klass.toLowerCase() + '/' + item.id"
                        (click)="viewItem(item)"
                        astrobinEventPreventDefault
                      >
                        <astrobin-equipment-item-display-name
                          [item]="item"
                          [showFrozenAsAmbiguous]="item.variants.length === 0"
                        ></astrobin-equipment-item-display-name>
                        <span
                          *ngIf="item.variants?.length > 0"
                          [innerHTML]="'+ {{numVariants}} variants' | translate: { numVariants: item.variants.length }"
                          class="variant-count"
                        >
                        </span>
                      </a>
                    </td>
                    <td>{{ equipmentItemService.humanizeType(item.klass) }}</td>
                    <td>{{ item.userCount }}</td>
                    <td>{{ item.imageCount }}</td>
                  </tr>
                </tbody>
              </table>

              <astrobin-image-search-card
                [header]="'Acquired with this brand' | translate"
                [model]="{
                  text: { value: activeBrand.name, matchType: MatchType.ALL, onlySearchInTitlesAndDescriptions: false }
                }"
                [showMarketplaceItems]="false"
                [showMoreButton]="false"
                [showRetailers]="false"
                [showStaticOverlay]="false"
                class="mt-5 d-block"
                ordering="-likes"
              ></astrobin-image-search-card>
            </ng-container>

            <ng-container *ngIf="!activeBrand">
              <ng-container
                *ngIf="(loadingService.loading$ | async) === false && paginatedBrands.length > 0; else loading"
              >
                <table class="table table-striped table-sm brands">
                  <thead>
                    <tr>
                      <th>
                        <button (click)="toggleAZSorting()" class="btn btn-link btn-no-block">
                          {{ "Name" | translate }}
                          <fa-icon *ngIf="sortOrder === ExplorerPageSortOrder.AZ_DESC" icon="sort-alpha-down"></fa-icon>
                          <fa-icon *ngIf="sortOrder === ExplorerPageSortOrder.AZ" icon="sort-alpha-up"></fa-icon>
                        </button>
                      </th>
                      <th>
                        <button (click)="toggleUsersSorting()" class="btn btn-link btn-no-block">
                          {{ "Users" | translate }}
                          <fa-icon
                            *ngIf="sortOrder === ExplorerPageSortOrder.USERS_DESC"
                            icon="sort-numeric-down"
                          ></fa-icon>
                          <fa-icon *ngIf="sortOrder === ExplorerPageSortOrder.USERS" icon="sort-numeric-up"></fa-icon>
                        </button>
                      </th>
                      <th>
                        <button (click)="toggleImagesSorting()" class="btn btn-link btn-no-block">
                          {{ "Images" | translate }}
                          <fa-icon
                            *ngIf="sortOrder === ExplorerPageSortOrder.IMAGES_DESC"
                            icon="sort-numeric-down"
                          ></fa-icon>
                          <fa-icon *ngIf="sortOrder === ExplorerPageSortOrder.IMAGES" icon="sort-numeric-up"></fa-icon>
                        </button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let brand of paginatedBrands" data-id="{{ brand.id }}">
                      <td>
                        <a
                          [href]="'/equipment/explorer/brand/' + brand.id + '/' + UtilsService.slugify(brand.name)"
                          (click)="viewBrand(brand)"
                          astrobinEventPreventDefault
                        >
                          {{ brand.name }}
                        </a>
                      </td>
                      <td>{{ brand.userCount }}</td>
                      <td>{{ brand.imageCount }}</td>
                    </tr>
                  </tbody>
                </table>

                <ngb-pagination
                  *ngIf="totalCount > 0"
                  [boundaryLinks]="true"
                  [collectionSize]="totalCount"
                  [maxSize]="5"
                  [rotate]="true"
                  (pageChange)="pageChange($event)"
                  [(page)]="currentPage"
                >
                  <ng-template ngbPaginationPrevious>&larr;</ng-template>
                  <ng-template ngbPaginationNext>&rarr;</ng-template>
                </ngb-pagination>
              </ng-container>

              <ng-container
                *ngIf="(loadingService.loading$ | async) === false && paginatedBrands.length === 0 && totalCount === 0"
              >
                <astrobin-nothing-here></astrobin-nothing-here>
              </ng-container>
            </ng-container>
            <!-- !activeBrand -->
          </ng-container>
        </div>
        <!-- brand main col -->

        <div
          *ngIf="!!listings && (listings.brandListings?.length > 0 || listings.itemListings?.length > 0)"
          class="col-sm-12 col-lg-3 sidebar"
        >
          <astrobin-equipment-listings
            [brand]="activeBrand"
            [listings]="listings"
            class="d-block mb-0 mb-lg-5"
          ></astrobin-equipment-listings>
        </div>
        <!-- brand side col -->
      </div>
      <!-- brand main row -->
    </div>
  </div>
</div>

<ng-template #loading>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>
